import PropTypes from 'prop-types';

var _a;
/**
 * @deprecated
 * We no longer use enums for props (so that we don't force the user to import the enum).
 * This enum will remain here for backwards compatibility purposes.
 */
var TextTypes;
(function (TextTypes) {
    TextTypes["H1"] = "h1";
    TextTypes["H2"] = "h2";
    TextTypes["H3"] = "h3";
    TextTypes["H4"] = "h4";
    TextTypes["H5"] = "h5";
    TextTypes["H6"] = "h6";
    TextTypes["SUB1"] = "sub1";
    TextTypes["SUB2"] = "sub2";
    TextTypes["P"] = "p";
    TextTypes["LABEL"] = "label";
    TextTypes["DEFAULTBUTTON"] = "defaultButton";
    TextTypes["SMALLBUTTON"] = "smallButton";
    TextTypes["NUMBER"] = "number";
    TextTypes["SUB3"] = "sub3";
    TextTypes["LABEL2"] = "label2";
    TextTypes["OVERLINE"] = "overline";
    TextTypes["LEGAL"] = "legal";
    TextTypes["BOLDPARAGRAPH"] = "boldParagraph";
    TextTypes["HYPERLINK"] = "hyperlink";
    TextTypes["LABEL1"] = "label1";
    TextTypes["PRIMARYBTN"] = "primarybtn";
    TextTypes["TERTIARYBTN"] = "tertiarybtn";
    TextTypes["BOLD"] = "bold";
})(TextTypes || (TextTypes = {}));
// this is just a tip on how to avoid using deprecated types.
// Will be displayed in the console if an deprecated type is passed.
var replacement = (_a = {},
    _a[TextTypes.SUB3] = 'p(Paragraph) + className property',
    _a[TextTypes.LABEL2] = 'label + className property',
    _a[TextTypes.OVERLINE] = 'p(Paragraph) + className property',
    _a[TextTypes.LEGAL] = 'p(Paragraph) + className property',
    _a[TextTypes.BOLDPARAGRAPH] = 'p(Paragraph) + isBold property',
    _a[TextTypes.HYPERLINK] = 'label + underline property',
    _a[TextTypes.LABEL1] = 'label',
    _a[TextTypes.PRIMARYBTN] = 'defaultButton',
    _a[TextTypes.TERTIARYBTN] = 'smallButton',
    _a[TextTypes.BOLD] = 'isBold property',
    _a);
Object.keys(replacement).join(', ');
var typeNames = Object.values(TextTypes);
typeNames.filter(function (item) { return !replacement[item]; });
var propTypes = {
    type: PropTypes.oneOf(Object.values(TextTypes)),
    children: PropTypes.node,
    className: PropTypes.string,
    color: PropTypes.string,
    fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isBold: PropTypes.bool,
    underline: PropTypes.bool,
    as: PropTypes.elementType,
    textRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.any }),
    ]),
    'data-testid': PropTypes.string,
    size: PropTypes.oneOf(['regular', 'large']),
};
var defaultProps = {
    type: TextTypes.P,
};

export { TextTypes, defaultProps, propTypes, replacement, typeNames };
